import { Box, Button, Editable, EditablePreview, EditableTextarea, Text } from '@chakra-ui/react';
import { deleteNote, replyNote, saveNotes } from './utils';
import React from 'react';
import { RiArrowRightDownLine, RiDeleteBinLine } from 'react-icons/ri';
import { MdOutlineQuickreply } from 'react-icons/md';

const EditableReply = ({ reply, noteOrder, replyOrder, notesUtils, noteStyles }) => {
  let date = reply.date;
  let time = '';
  if (typeof reply.date === 'object') {
    date = reply.date.date;
    time = reply.date.time;
  }
  return (
    <Box sx={{ ...noteStyles }}>
      <Box marginBottom="1rem">
        <Box display="flex" >
          <Box className="editableWrapper" width="100%">
            <Box className="ownerWrapper" width="5%">
              <text className="owner">{reply.owner}</text>
            </Box>
            <Box className="editableTag" width="35%" background="#D7DDE8" paddingLeft=".5rem" paddingTop=".2rem"><Text
              className="date">{date}</Text> <Text className="time">{time}</Text>
            </Box>
            <Box width="60%" background="#D7DDE8" cursor="pointer" textAlign="right" paddingRight="1rem"
                 paddingTop=".2rem"
                 onClick={(e) => notesUtils.toggle(e, reply.id)}
            >+</Box>
          </Box>
        </Box>
        <Box id={reply.id} display="none" marginLeft="5%" paddingLeft="1.3rem">
          <Editable className="editableTag" autoResize defaultValue={reply.note}>
            <EditablePreview />
            <EditableTextarea onBlur={(e) => notesUtils.changeReply(e, 'note', noteOrder,replyOrder)}
            />
          </Editable>
          <Box className="editNoteButtons">
            <Box className="editNoteButtonWrapper">
              <Text className="editNoteButton" onClick={() => notesUtils.deleteReply(noteOrder,replyOrder)}><RiDeleteBinLine
                className="greenHover" /></Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default EditableReply;
/*

    <Box sx={{ ...noteStyles }}>

      <Box display="flex"  >
        <RiArrowRightDownLine />
        <Box className="ownerWrapper">
          <text className="owner">{reply.owner}</text>
        </Box>
        <Box className="editableTag date">{reply.date}
        </Box>
        <Box>
          <Editable className="editableTag" autoResize defaultValue={reply.note}>
            <EditablePreview />
            <EditableTextarea onBlur={(e) => notesUtils.changeReply(e, 'note', noteOrder,replyOrder)}
            />
          </Editable>
        </Box>
        <Box className="editNoteButtons">
          <Box className="editNoteButtonWrapper">
            <Text className="editNoteButton" onClick={() => notesUtils.deleteReply(noteOrder,replyOrder)}><RiDeleteBinLine /></Text>
          </Box>
        </Box>
      </Box>
    </Box>
 */